import React from 'react';
import { useNavigate } from 'react-router-dom';
import { motion } from 'framer-motion';
import SafeIcon from '../common/SafeIcon';

const CreateChoice = () => {
  const navigate = useNavigate();

  return (
    <motion.div
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      className="p-6 h-full bg-white flex flex-col"
    >
      <header className="flex items-center mb-8 pt-4">
        <button onClick={() => navigate('/home')} className="p-2 -ml-2 text-gray-600">
          <SafeIcon name="ChevronLeft" className="text-2xl" />
        </button>
        <h1 className="flex-1 text-center text-lg font-bold text-gray-800 pr-8">Create New</h1>
      </header>

      <div className="space-y-5 flex-1">
        <motion.div
          initial={{ y: 20, opacity: 0 }}
          animate={{ y: 0, opacity: 1 }}
          transition={{ delay: 0.1 }}
          onClick={() => navigate('/create/singles')}
          className="relative overflow-hidden p-6 rounded-2xl bg-gradient-to-br from-pink-500 via-rose-500 to-red-500 text-white cursor-pointer shadow-lg shadow-pink-200 hover:shadow-xl transition-all group"
        >
          <div className="absolute top-0 right-0 w-32 h-32 bg-white/10 rounded-full -translate-y-8 translate-x-8" />
          <div className="relative z-10">
            <div className="flex items-center gap-3 mb-3">
              <div className="w-12 h-12 bg-white/20 backdrop-blur-sm rounded-xl flex items-center justify-center">
                <span className="text-2xl">💌</span>
              </div>
              <div>
                <h3 className="text-xl font-bold">Singles</h3>
                <p className="text-pink-100 text-xs">Fun invitation game</p>
              </div>
            </div>
            <p className="text-pink-100 text-sm leading-relaxed">
              Create a playful invitation with your profile, music, and a question.
            </p>
          </div>
        </motion.div>

        <motion.div
          initial={{ y: 20, opacity: 0 }}
          animate={{ y: 0, opacity: 1 }}
          transition={{ delay: 0.2 }}
          onClick={() => navigate('/create/couples')}
          className="relative overflow-hidden p-6 rounded-2xl bg-gradient-to-br from-purple-500 via-violet-500 to-indigo-500 text-white cursor-pointer shadow-lg shadow-purple-200 hover:shadow-xl transition-all group"
        >
          <div className="absolute top-0 right-0 w-32 h-32 bg-white/10 rounded-full -translate-y-8 translate-x-8" />
          <div className="relative z-10">
            <div className="flex items-center gap-3 mb-3">
              <div className="w-12 h-12 bg-white/20 backdrop-blur-sm rounded-xl flex items-center justify-center">
                <span className="text-2xl">💕</span>
              </div>
              <div>
                <h3 className="text-xl font-bold">Couples</h3>
                <p className="text-purple-100 text-xs">Digital love card</p>
              </div>
            </div>
            <p className="text-purple-100 text-sm leading-relaxed">
              Send a romantic message with photos, music, and an optional date plan.
            </p>
          </div>
        </motion.div>
      </div>
    </motion.div>
  );
};

export default CreateChoice;